// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"a9c40f49","603":"bbfb7c8e"}[chunkId] + ".chunk.css";
};